// extracted by mini-css-extract-plugin
export var navigation = "navigation-module--navigation--Y7+yf";
export var active = "navigation-module--active--CAy3t";
export var icon = "navigation-module--icon--s5Xel";
export var line = "navigation-module--line--vIt0u";
export var line2 = "navigation-module--line2--j74lk";
export var line1 = "navigation-module--line1--YHj6C";